<template>
  <div>
    <div class="header">
      <el-image class="logo" :src="logo" mode="heightFix"></el-image>
      <div class="go_back" @click="go_back">
        <span class="el-icon-s-home" style="color: #E40080;line-height: 38px"></span>
        <span class="go_back_text">返回首页</span>
      </div>
      <div class="right">
        <div class="username">登录名：{{ userInfor.mobile }}</div>
        <!--        <div class="border">公司：{{ userInfor.name_cn }}</div>-->
        <div class="pointer logout" @click="logout">
          退出
          <el-image
              class="ex-image"
              :src="exitIcon"
              style="width: 18px; height: 18px; margin-left: 5px"
          ></el-image>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {logOut} from "@/api/api";
export default {
  components: {},
  data() {
    return {
      logo: require("../assets/logo.jpg"),
      exitIcon: require("../assets/exit_1.jpg"),
      userInfor: {},
    };
  },
  mounted() {
    this.userInfor = JSON.parse(localStorage.getItem("userdata"));
  },
  created() {
  },
  methods: {
    logout() {
      this.$confirm("确定要退出吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            logOut()
                .then((res) => {
                  console.log(res, "======退出");
                  if (res.code == 1) {
                    let loginRes = {
                      token: null,
                      isLogin: false,
                    };
                    this.$store.commit("userStatus", loginRes);
                    localStorage.clear();
                    // 状态保持清除后刷新页面
                    window.location.reload();
                    this.$router.push({
                      path: "/login",
                    });
                  }
                })
                .catch((err) => {
                  console.log(err);
                });
          })
          .catch(() => {
            // this.$message({
            //     type: "info",
            //     message: "已取消删除",
            // });
          });
    },
    go_back(){
      if(this.$route.path=='/home'){
        window.location.reload();
      }else {
        this.$router.push({ path: '/home' })
      }
    }
  },
};
</script>
<style lang="scss">
.xfBox {
  padding: 0 !important;
  width: 88px;
  height: 32px;
  background: #F7A1A9;
  line-height: 32px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
  text-align: center;
  border-radius: 8px;
  cursor: pointer;
}

.bell {
  width: 20px;
  height: 20px;
  margin-left: 40px;

}

.star {
  text-align: center;
}

.star_bell {
  width: 25px;
}

.star_text {
  font-size: 10px;
  color: #ffffff;
}

.headerstatus {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
}

.headertips {
  margin-right: 40px;
  display: flex;
  align-items: center;
}

.headertips span:nth-child(1) {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 10px;
}

.wcz {
  background: #c0c4cc;
  border: 1px solid rgba(255, 255, 255, 0.88);
}

.jxz {
  background: #ffb800;
  border: 1px solid rgba(255, 255, 255, 0.88);
}

.ywc {
  //background: #52C41A;
  background: #E40080;
  border: 1px solid rgba(255, 255, 255, 0.88);
}

.cz {
  margin-left: 76px;
}

.header {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 40px 0 30px;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  background: #E40080;
  z-index: 19999;

  .logo {
    width: 150px;
    // height: 62px;
    // line-height: 62px;
    text-align: center;
    margin-left: 38px;
  }

  .username {
    color: #fff;
  }

  .border {
    color: #fff;
  }

  .logo-white {
    display: none;
  }

  .header-title {
    font-size: 30px;
    font-weight: bold;
    color: #2c2c2e;
    margin: 0 60px 0 60px;
  }

  .right {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-size: 14px;

    > div {
      padding: 0 20px;
    }

    .message {
      position: relative;

      .message-tips {

        position: absolute;
        top: -4px;
        right: 15px;
        width: 16px;
        height: 16px;
        color: #fff;
        font-size: 12px;
        line-height: 16px;
        border-radius: 50%;
        text-align: center;
        background: #ff4d4f;
      }
    }

    .border {
      border-left: 1px solid #fff;
      border-top: 0 none;
      border-bottom: 0 none;
    }

    .pointer {
      cursor: pointer;
    }

    .logout {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 66px;
      height: 26px;
      padding: 0;
      transition: all 0.2s;
      color: #fff;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;

      .ex-image2 {
        display: none;
      }
    }

    .logout:hover {
      color: #fff;
      text-decoration: underline;

    }
  }
}

.messagebtn {
  width: 146px;
  height: 40px;
  overflow: hidden;
  font-size: 16px;
  border: 0 none !important;
  background: #2c2c2e !important;
  border-radius: 5px;
}

.header-dialog .el-icon-close:hover {
  color: #E40080;
}

.header-dialog .el-dialog__header {
  padding-bottom: 0;
}

.header-dialog .el-dialog__body {
  padding-top: 0;
}

.header-dialog {
  overflow-y: hidden;
}

.header-dialog .el-dialog {
  margin-top: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

@media (max-width: 1366px) {
  .header-title {
    font-size: 24px !important;
    margin: 0 30px 0 34px !important;

  }
}

@media (max-width: 1024px) {
  .header-title {
    font-size: 20px !important;
    margin: 0 30px 0 34px !important;

  }
  .header .right > div {
    padding: 0px 9px;
  }

}

@media only screen and (max-width: 767px) {
  .header {
    height: 60px;
    padding: 0 18px 0 15px;
    background: #2c2c2e;
    justify-content: inherit;

    .header-title {
      display: none;

    }

    .cz {
      display: none;
    }

    .username {
      display: none;
      color: #fff;
    }

    .border {
      display: none;
    }

    .right {
      color: #fff;
      position: relative;
      justify-content: inherit;
      font-size: 12px !important;

      > div {
        padding: 0 6px;
      }

      .border {
        border-color: #fff;
      }

      .logout {
        color: #2c2c2e;
        position: absolute;
        right: 0;
      }
    }

    .logo {
      display: none;
    }

    .logo-white {
      width: 46px;
      // height: 30px;
      display: block;
    }

  }
}


.go_back {
  width: 106px;
  height: 38px;
  background: #FFFFFF;
  border-radius: 23px;
  text-align: center;
  margin-left: 50px;
  cursor: pointer;
}

.go_back_text {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #E40080;
  line-height: 38px;
  text-align: center;
  font-style: normal;
}
</style>
